<template>
  <div>
    <div
      class="showBox"
      v-if="!rightComponents"
      @click="xxx"
    >
      <i class="el-icon-arrow-down el-icon-arrow-left "></i>
    </div>
    <div
      class="rightNav"
      id="pp"
      v-if="rightComponents"
    >
      <span
        class="open"
        @click.stop="xxx"
      >隐藏<i class="el-icon-arrow-down el-icon--right"></i></span>
      <div
        @mouseover="act(1)"
        @mouseleave="leave(1)"
      >
        <el-popover
          width="168"
          popper-class="navItem one"
          placement="left-start"
          trigger="hover"
        >
          <div class="gmat_time">
            <p>GMAT换库时间</p>
            <ul class="gmat_ul">
              <li>{{ch_time}}</li>
            </ul>
            <p>重库情况</p>
            <ul class="gmat_stor">
              <li>{{storage}}</li>
            </ul>
          </div>
          <div
            class="icon"
            slot="reference"
          >
            <p><img
                :src="icon1"
                alt=""
              ></p>
            <p>换库时间</p>
          </div>
        </el-popover>
      </div>
      <div
        @mouseover="act(2)"
        @mouseleave="leave(2)"
      >
        <el-popover
          width="215"
          popper-class="navItem two"
          placement="left"
          trigger="hover"
        >
          <div class="gmat_free">
            <p>免费公开课</p>
            <p>老师：<span v-if="open[0]">{{open[0].teacher_name}} </span></p>
            <p>时间：<span>{{openListTime}}</span></p>
            <p>内容：<span v-if="open[0]">{{open[0].position}} </span></p>
          </div>
          <div
            class="icon"
            slot="reference"
          >
            <p><img
                :src="icon2"
                alt=""
              ></p>
            <p>免费公开课</p>
          </div>
        </el-popover>
      </div>
      <div
        @mouseover="act(3)"
        @mouseleave="leave(3)"
      >
        <el-popover
          popper-class="navItem three"
          width="215"
          placement="left"
          trigger="hover"
        >
          <div
            class="gmat_newest"
            v-if="free[0]"
          >
            <p>最新刷题班</p>
            <p>老师：<span v-if="free[0]">{{free[0].teacher_name}}</span></p>
            <p>时间：<span>{{freeListTime}}</span></p>
            <p>内容：<span v-if="free[0]">{{free[0].description}}</span></p>
          </div>
          <div
            class="icon"
            slot="reference"
          >
            <p><img
                :src="icon3"
                alt=""
              ></p>
            <p>最新刷题班</p>
          </div>
        </el-popover>
      </div>
      <div>
      </div>
      <div
        @mouseover="act(5)"
        @mouseleave="leave(5)"
      >
        <el-popover
          popper-class="navItem four"
          placement="left"
          width="200"
          trigger="hover"
        >
          <div class="gmat_scanCode">
            <p>扫码添加微信小助手</p>
            <p><img
                src="../assets/rightNav/nav/1.png"
                alt=""
              ><img
                src="../assets/rightNav/nav/2.png"
                alt=""
              ></p>
            <p>jjgmat780 / jjgmat800</p>
          </div>
          <div
            class="icon"
            slot="reference"
          >
            <p><img
                :src="icon5"
                alt=""
              ></p>
            <p>小助手微信</p>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import api from "@/api/home.js";
import API from "@/api/activeTest.js";
export default {
  data() {
    return {
      icon1: require("../assets/rightNav/nav/icon7.png"),
      icon1Org: require("../assets/rightNav/nav/icon7.png"),
      icon1Act: require("../assets/rightNav/nav/icon9.png"),
      icon2: require("../assets/rightNav/nav/icon2.png"),
      icon2Org: require("../assets/rightNav/nav/icon2.png"),
      icon2Act: require("../assets/rightNav/nav/icon4.png"),
      icon3: require("../assets/rightNav/nav/icon1.png"),
      icon3Org: require("../assets/rightNav/nav/icon1.png"),
      icon3Act: require("../assets/rightNav/nav/icon3.png"),
      icon5: require("../assets/rightNav/nav/icon8.png"),
      icon5Org: require("../assets/rightNav/nav/icon8.png"),
      icon5Act: require("../assets/rightNav/nav/icon5.png"),
      rightComponents: true,
      info: {},
      // 换库
      ch_time: null,
      storage: null,
      num: 0,
      openClassListTime: "",
      freeListTime: "",
      openListTime: "",
      // 免费公开课
      open: [
        {
          teacher_name: "",
        },
      ],
      // 最新刷题班
      free: [
        {
          teacher_name: "",
        },
      ],
    };
  },
  mounted() {
    this.getClass();
    api
      .rightCon()
      .then((res) => {
        // console.log(res.data.code, "code");
        if (res.data.code == 0) {
          this.info = res.data.data;
          // console.log(this.info);
        }
      })
      .catch((err) => {
        this.$message.error("标签获取失败");
      });
  },
  methods: {
    xxx() {
      //  console.log(this.rightComponents)
      this.rightComponents = !this.rightComponents;
    },
    act(i) {
      // console.log(i);
      if (i == 1) {
        this.icon1 = this.icon1Act;
      } else if (i == 2) {
        this.icon2 = this.icon2Act;
      } else if (i == 3) {
        this.icon3 = this.icon3Act;
      } else {
        this.icon5 = this.icon5Act;
      }
    },
    leave(i) {
      // console.log(i);
      if (i == 1) {
        this.icon1 = this.icon1Org;
      } else if (i == 2) {
        this.icon2 = this.icon2Org;
      } else if (i == 3) {
        this.icon3 = this.icon3Org;
      } else {
        this.icon5 = this.icon5Org;
      }
    },
    leavess() {
      nb_nodeboard_close.click();
    },
    goK() {
      nb_icon_wrap.click();
    },
    getClass() {
      API.getOpenClass()
        .then((res) => {
          console.log(res);
          // 免费公开课
          let list = res.data.data[0];
          let arr = [];

          function freeTime(list) {
            let aTime = Math.round(new Date().getTime() / 1000);
            list.forEach((item, i) => {
              let b = item.dates;
              if (b > aTime) {
                // console.log('小于今天的时间过滤')
                arr.push(item);
              }
            });

            function compare(t) {
              return function (a, b) {
                var at = a[t];
                var bt = b[t];
                return at - bt;
              };
            }
            arr.sort(compare("dates"));
            // console.log(arr,'过滤后的时间戳1公开课');
          }
          freeTime(list);
          console.log(arr);
          this.open = arr;
          this.openListTime = "2021-" + arr[0].date + " " + arr[0].end_time;
          //   this.openListTime = "2021-" + list[0].date + " " + list[0].time;
          //   this.open = list;
          // this.openClassListTime = res.data.data[0][res.data.data[0].length - 1].date + " " + res.data.data[0][res.data.data[0].length - 1].time;
          // console.log(list,'免费公开课');
          // console.log(this.openClassListTime);
        })
        .catch((err) => {
          // this.$message.error('数据获取失败');
        });
      API.freeClass()
        .then((res) => {
          // 最新刷题班
          let list = res.data.data;
          let arr = [];

          function freeTime(list) {
            let aTime = Math.round(new Date().getTime() / 1000);
            list.forEach((item, i) => {
              let b = item.dates;
              if (b > aTime) {
                // console.log('小于今天的时间过滤')
                arr.push(item);
              }
            });

            function compare(t) {
              return function (a, b) {
                var at = a[t];
                var bt = b[t];
                return at - bt;
              };
            }
            // arr.sort(compare('dates'));
            // console.log(arr,'过滤后的时间戳训练营');
          }
          freeTime(list);
          this.free = arr;
          this.freeListTime = arr[0].date + " 到 " + arr[0].end_time;
        })
        .catch((err) => {
          // this.$message.error('数据获取失败');
        });
      API.config()
        .then((res) => {
          this.ch_time = res.data.data.chang_time;
          this.storage = res.data.data.storage;
          // console.log(res,'换库时间');
        })
        .catch((err) => {
          // this.$message.error('数据获取失败');
        });
    },
    closeRight() {
      this.rightComponents = false;
    },
    cut() {
      setTimeout(() => {
        if (this.num == 0) {
          this.num = 1;
        } else {
          this.num = 0;
        }
      }, 500);
    },
  },
};
</script>
<style scoped>
.showBox {
  width: 40px;
  height: 40px;
  box-shadow: -2px 0 8px 0 rgba(0, 0, 0, 0.08);
  background: #fff;
  text-align: center;
  line-height: 40px;
  position: fixed;
  right: 0;
  top: 30%;
  z-index: 9998;
  border-radius: 10px 0px 0px 10px;
}

.open {
  cursor: pointer;
  margin-left: 10px;
  font-size: 5px;
}

.open:hover {
  cursor: pointer;
  color: #92d0ff;
}

.rightNav {
  position: fixed;
  top: 20%;
  right: 0;
  z-index: 9999;
  width: 76px;
  border-radius: 8px;
  text-align: center;
  padding: 0 5px;
  box-shadow: -2px 0 8px 0 rgba(0, 0, 0, 0.08);
  background: #fff;
  /* overflow: hidden;
        -webkit-transition-duration: 300ms;
        -moz-transition-duration: 300ms;
        -ms-transition-duration: 300ms;
        -o-transition-duration: 300ms;
        transition-duration: 300ms; */
}

.rightNav .icon {
  border-bottom: 1px solid #f0f1f5;
  padding-top: 14px;
  box-sizing: border-box;
  width: 100%;
  height: 77px;
  position: relative;
}

.rightNav .icon:hover {
  cursor: pointer;
  background: #77d639;
  color: #fff;
}

.rightNav .icon > p {
  margin: 0;
  padding: 0;
}

.rightNav .icon > p img {
  margin-bottom: 6px;
}

.rightNav .icon > p:nth-child(1) {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.rightNav .icon > p:nth-child(2) {
  font-size: 8px;
  align-items: flex-start;
  justify-content: center;
}

.rightNav > div:nth-child(4) .icon:hover {
  color: #fff;
  background: #fec8cb;
}

.rightNav > div:nth-child(3) .icon:hover {
  background: #aaabe8;
  color: #fff;
}

.rightNav > div:nth-child(2) .icon:hover {
  color: #fff;
  background: #92d0ff;
}

.gmat_time > p:nth-child(1) {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 2px;
}

.gmat_time > p:nth-child(3) {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  margin-bottom: 2px;
  color: #ffffff;
}

.gmat_ul > li {
  margin-left: 25px;
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 6px;
}

.gmat_stor > li {
  margin-left: 25px;
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 6px;
}

.gmat_free > p:nth-child(1) {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 8px;
}

.gmat_free > p:nth-child(2) {
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  margin-bottom: 8px;
  color: #ffffff;
}

.gmat_free > p:nth-child(2) > span {
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
}

.gmat_free > p:nth-child(3) {
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  margin-bottom: 8px;
  color: #ffffff;
}

.gmat_free > p:nth-child(3) > span {
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
}

.gmat_free > p:nth-child(4) {
  font-size: 12px;
  margin-bottom: 8px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
}

.gmat_free > p:nth-child(4) > span {
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
}

.gmat_newest > p:nth-child(1) {
  font-size: 14px;
  font-family: Source Han Sans SC;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 8px;
}

.gmat_newest > p:nth-child(2) {
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  margin-bottom: 8px;
  color: #ffffff;
}

.gmat_newest > p:nth-child(2) > span {
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
}

.gmat_newest > p:nth-child(3) {
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  margin-bottom: 8px;
  color: #ffffff;
}

.gmat_newest > p:nth-child(3) > span {
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
}

.gmat_newest > p:nth-child(4) {
  font-size: 12px;
  margin-bottom: 8px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
}

.gmat_newest > p:nth-child(4) > span {
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
}

.gmat_scanCode > p:nth-child(1) {
  text-align: center;
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 11px;
}

.gmat_scanCode > p:nth-child(2) {
  margin-bottom: 11px;
}

.gmat_scanCode > p:nth-child(2) > img:nth-child(1) {
  width: 70px;
  height: 70px;
  margin-left: 10px;
}

.gmat_scanCode > p:nth-child(2) > img:nth-child(2) {
  width: 70px;
  height: 70px;
  margin-left: 10px;
}

.gmat_scanCode > p:nth-child(3) {
  text-align: center;
  font-size: 12px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/rightNav.vue